import React, { useEffect, useState } from 'react';
import AdminLayout from '@/components/admin/AdminLayout';
import { API, toast } from '@/App';
import axios from 'axios';
import { Mail, MailOpen, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

const AdminMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const response = await axios.get(`${API}/contact`);
      setMessages(response.data);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      await axios.patch(`${API}/contact/${id}/read`);
      fetchMessages();
    } catch (error) {
      toast.error('Bir hata oluştu!');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bu mesajı silmek istediğinizden emin misiniz?')) return;
    try {
      await axios.delete(`${API}/contact/${id}`);
      toast.success('Mesaj silindi!');
      fetchMessages();
    } catch (error) {
      toast.error('Silme başarısız!');
    }
  };

  return (
    <AdminLayout>
      <div data-testid="admin-messages-page">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Mesajlar</h1>
          <p className="text-white/60">Gelen iletişim mesajlarını görüntüleyin</p>
        </div>

        {loading ? (
          <div className="text-white/60">Yükleniyor...</div>
        ) : messages.length === 0 ? (
          <div className="glass p-8 rounded-2xl text-center text-white/60" data-testid="no-messages">
            Henüz mesaj yok.
          </div>
        ) : (
          <div className="space-y-4">
            {messages.map((message) => (
              <div
                key={message.id}
                data-testid={`message-item-${message.id}`}
                className={`glass p-6 rounded-2xl ${
                  message.read ? 'opacity-60' : 'border-l-4 border-[#FF6B35]'
                }`}
              >
                <div className="flex justify-between items-start mb-4">
                  <div className="flex items-center space-x-3">
                    {message.read ? (
                      <MailOpen className="w-5 h-5 text-white/40" />
                    ) : (
                      <Mail className="w-5 h-5 text-[#FF6B35]" />
                    )}
                    <div>
                      <h3 className="font-semibold">{message.name}</h3>
                      <p className="text-sm text-white/60">{message.email}</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-xs text-white/50">
                      {new Date(message.created_at).toLocaleDateString('tr-TR')}
                    </span>
                    {!message.read && (
                      <Button
                        size="sm"
                        onClick={() => markAsRead(message.id)}
                        data-testid={`mark-read-${message.id}`}
                        className="bg-white/5 hover:bg-white/10"
                      >
                        Okundu Işaretle
                      </Button>
                    )}
                    <button
                      onClick={() => handleDelete(message.id)}
                      data-testid={`delete-message-${message.id}`}
                      className="p-2 rounded-lg bg-white/5 hover:bg-red-500/20 text-red-500"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>
                <div className="space-y-2 text-sm">
                  <div>
                    <span className="text-white/50">Konu: </span>
                    <span className="font-medium">{message.subject}</span>
                  </div>
                  {message.phone && (
                    <div>
                      <span className="text-white/50">Telefon: </span>
                      <span>{message.phone}</span>
                    </div>
                  )}
                  <div className="mt-4 p-4 bg-white/5 rounded-lg">
                    <p className="text-white/80 whitespace-pre-wrap">{message.message}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminMessages;